export const isPositiveNumericField = (event: KeyboardEvent): boolean => {
	// biome-ignore lint/performance/useTopLevelRegex: <explanation>
	const pattern = /^([0-9])$/;
	const result = pattern.test(event.key);
	return result;
};
